import {AxiosResponse} from "axios";
import {axiosInstance} from "../utils/axiosInstance";
import type {AllNews, SingleNews} from "./types/news";
import {AllNewsFilter} from "./types/news";

const mainEndpoint = 'admin/news'

// fetch all news
export async function fetchAllNews(searchParams: AllNewsFilter): Promise<AxiosResponse<AllNews>> {
    return await axiosInstance.get(mainEndpoint, {params: searchParams});
}

// fetch all news
export async function fetchSingleNews(id: number): Promise<AxiosResponse<SingleNews>> {
    const endpoint = `${mainEndpoint}/${id}`;
    return await axiosInstance.get(endpoint);
}

export async function updateNews(id, data): Promise<any> {
    const endpoint = `${mainEndpoint}/${id}/`
    return await axiosInstance.put(endpoint, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export async function deleteNews(id: number): Promise<AxiosResponse<AllNews>> {
    const endpoint = `${mainEndpoint}/${id}`;
    return await axiosInstance.delete(endpoint);
}
